if (window.location.href.includes("/loyalty")) {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  if (email) {
    console.log("Email:", email);

    const emailInput = document.getElementById("email");
    if (emailInput) {
      emailInput.value = email;
    }
  } else {
    console.log("Email parameter not found in the URL.");
  }
}
// Check if the browser is Safari
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

// Apply transformation with a 2-second delay if it's Safari
if (isSafari) {
    setTimeout(function() {
        $('button.button-link-text img').attr('style', 'transform: rotate(90deg)');
    }, 2000); // 2000 milliseconds = 2 seconds
}

